import { useState, useEffect } from "react";
import { Box, Text, Button, Badge } from "@chakra-ui/react";
import {
  AiFillWarning,
  AiFillCheckCircle,
  AiFillExclamationCircle,
} from "react-icons/ai";
import dayjs from "dayjs";

const paymentDescriptions = {
  PAID: {
    desc: "Paid",
    icon: <AiFillCheckCircle />,
    colour: "green",
    dateText: "Paid on: ",
  },
  UNPAID: {
    desc: "Awaiting payment",
    icon: <AiFillWarning />,
    colour: "orange",
    dateText: "",
  },
  CANCELLED: {
    desc: "Payment cancelled",
    icon: <AiFillExclamationCircle />,
    colour: "red",
    dateText: "Cancelled on: ",
  },
  FAILED: {
    desc: "Payment failed",
    icon: <AiFillExclamationCircle />,
    colour: "red",
    dateText: "Failed on: ",
  },
};

const VerificationStatusBox = ({
  paymentStatus,
  paidDate,
  cancelledDate,
  onStartPay,
  hasAssociations,
}) => {
  const [paymentState, setPaymentState] = useState(paymentStatus);

  useEffect(() => {
    setPaymentState(paymentStatus);
  }, [paymentStatus]);

  return (
    <div className="flex flex-col w-full items-start rounded-lg shadow p-2">
      <div className="flex items-center mb-2">
        <Text fontSize="xl">Verification payment status:</Text>
        <Badge
          ml={2}
          borderRadius={10}
          colorScheme={paymentDescriptions[paymentState].colour}
        >
          <Box p={1} display="flex" flexDirection="row" alignItems="center">
            <Box mr={2}>{paymentDescriptions[paymentState].icon}</Box>
            {paymentDescriptions[paymentState].desc}
          </Box>
        </Badge>
      </div>
      {paymentStatus !== "UNPAID" && (
        <div className="flex items-center">
          <p className="text-sm mr-1">
            {paymentDescriptions[paymentState].dateText}
          </p>
          <p className="text-sm font-bold">
            {dayjs(paymentStatus === "PAID" ? paidDate : cancelledDate).format(
              "DD-MM-YYYY"
            )}
          </p>
        </div>
      )}
      {paymentStatus === "PAID" ? (
        <div className="flex items-center">
          <p className="text-sm mr-1">Renewal Date:</p>
          <p className="text-sm font-bold">
            {dayjs(paidDate).add(1, "y").format("DD-MM-YYYY")}
          </p>
        </div>
      ) : hasAssociations ? (
        <Button id="therapist-dashboard-pay-now-pressed" onClick={onStartPay}>
          {paymentStatus === "UNPAID" ? "Pay now" : "Resubscribe Now"}
        </Button>
      ) : null}
    </div>
  );
};

export default VerificationStatusBox;
